import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { useMemo } from 'react';
import { theme } from '@xbto/design-system';
import { Box, Col, Row } from '../../../atoms';
import { useBreakpoints } from '../../../hooks';
import { FundGraphMetrics } from '../metrics';
import cx from 'classnames';
import { AssetFundChartTimeRange } from 'common';
import { StatusButton, RadioGroup } from '../../../molecules';
export const Container = ({ children, accountDetailAsset, selectedSeries, onTimeRange, timeRange, hideTimeRange = false, onSeriesToggle, hideUsdLegend = false, lessThan1Year = false, loading, }) => {
    const { breakpoints } = useBreakpoints();
    const timeRangeItems = useMemo(() => {
        const itd = {
            label: breakpoints.LESS_THAN_S ? 'ITD' : 'Since inception',
            value: AssetFundChartTimeRange.SINCE_INCEPTION,
        };
        return lessThan1Year
            ? [itd]
            : [{ label: '1Y', value: AssetFundChartTimeRange.Y1 }, itd];
    }, [breakpoints.LESS_THAN_S, lessThan1Year]);
    return (_jsxs(Col, { children: [_jsxs(Col, { style: StyleSheet.flatten([
                    $.container,
                    breakpoints.LESS_THAN_M && $.container_M,
                ]), children: [!hideTimeRange && (_jsxs(Row.LR, { mb: "6", children: [_jsxs(Row.C, { children: [_jsx(Box, { mr: "4", children: _jsx(StatusButton, { label: "Asset amount", iconColor: 'info', onPress: () => onSeriesToggle('asset-amount'), disabled: loading }) }), !hideUsdLegend && (_jsx(StatusButton, { label: "USD value", iconColor: 'warning', onPress: () => onSeriesToggle('usd-value'), disabled: loading }))] }), timeRangeItems.length > 1 && (_jsx(Row.C, { children: _jsx(RadioGroup, { items: timeRangeItems, onChange: onTimeRange, value: timeRange, disabled: loading }) }))] })), _jsx(_Fragment, { children: children })] }), !!accountDetailAsset && (_jsx("div", { className: cx('grid gap-2 w-full max-w-full mt-4', breakpoints.LESS_THAN_S ? 'grid-rows-4' : 'grid-cols-4'), children: _jsx(FundGraphMetrics, { series: selectedSeries, accountDetailAsset: accountDetailAsset }) }))] }));
};
const $ = StyleSheet.create({
    container: {
        borderWidth: 1,
        borderColor: theme.color.border.primary,
        borderRadius: theme.radius.md,
        padding: theme.spacing['4'],
    },
    container_M: {
        borderRadius: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        paddingHorizontal: theme.spacing['4'],
        paddingTop: theme.spacing['6'],
        paddingBottom: theme.spacing['8'],
        marginHorizontal: -1 * theme.spacing['4'],
    },
});
